import { createSlice } from '@reduxjs/toolkit';

// Бейдж меню Inventory = сколько предметов (части героев, сундуки, ключи) получено
// с последнего захода в Inventory. Чисто клиентский счётчик — бэкенд о нём не знает.
// Живёт в localStorage (per user); сбрасывается в Menu, когда открыт /inventory.
const STORAGE_PREFIX = 'datum.inventoryNew.v1.';

// Типы наград, которые кладутся в инвентарь (rewardType из ачивок/BattlePass и type из RewardModal)
export const INVENTORY_REWARD_TYPES = ['CHARACTER_MODULE', 'MODULE', 'CHEST', 'KEY'];

export function loadInventoryNewCount(userId) {
  try {
    const n = Number(window.localStorage.getItem(STORAGE_PREFIX + userId));
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function saveInventoryNewCount(userId, count) {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + userId, String(count));
  } catch {
    // приватный режим / квота — бейдж просто не переживёт перезапуск
  }
}

// Сколько предметов инвентаря в списке наград; qty(reward) — количество в конкретной награде
export const countInventoryRewards = (rewards, qty) =>
  (rewards || [])
    .filter((r) => INVENTORY_REWARD_TYPES.includes(r?.rewardType))
    .reduce((sum, r) => sum + Math.max(1, Number(qty(r)) || 0), 0);

const initialState = {
  userId: null,
  count: 0,
};

const inventoryNewSlice = createSlice({
  name: 'inventoryNew',
  initialState,
  reducers: {
    hydrateInventoryNew: (state, action) => {
      const { userId, saved } = action.payload;
      if (state.userId === userId) return;
      // То, что успели получить до гидрации (userId ещё не загружен), не теряем
      state.count = (state.userId == null ? state.count : 0) + (Number(saved) || 0);
      state.userId = userId;
    },
    addNewInventoryItems: (state, action) => {
      const n = Number(action.payload) || 0;
      if (n > 0) state.count += n;
    },
    resetNewInventoryItems: (state) => {
      state.count = 0;
    },
  },
});

export const { hydrateInventoryNew, addNewInventoryItems, resetNewInventoryItems } = inventoryNewSlice.actions;
export default inventoryNewSlice.reducer;
